import { wpPages } from '../../content/wpPages.generated';
import { siteIdentity } from '../../content/siteContent';
import { BlockRenderer, mediaUrl } from '../components/BlockRenderer';
import type { PageBlock } from '../../lib/types';

function isImage(block: PageBlock): block is Extract<PageBlock, { type: 'image' }> {
  return block.type === 'image';
}

export function GalleryPage() {
  const { title, blocks } = wpPages.gallery;
  const imageBlocks = blocks.filter(isImage);
  const otherBlocks = blocks.filter((block) => !isImage(block));

  return (
    <section className="gallery-page">
      <header className="page-hero">
        <p className="eyebrow">{siteIdentity.name}</p>
        <h1>{title}</h1>
      </header>
      <section className="prose"><BlockRenderer blocks={otherBlocks} /></section>
      <div className="gallery-grid">
        {imageBlocks.map((block) => (
          <figure key={block.id}>
            <img src={mediaUrl(block.mediaId)} alt={block.altText} loading="lazy" />
            {block.caption && <figcaption>{block.caption}</figcaption>}
          </figure>
        ))}
      </div>
    </section>
  );
}
